"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
}); // https://www.justice.gov/ust/eo/bapcpa/20250401/bci_data/median_income_table.htm

function getStateMedianFamilyIncome(dirtyState, persons) {
  if (!dirtyState) throw new Error("Missing State");
  var state = dirtyState.toUpperCase();
  if (!persons || persons === 0 || Number.isNaN(persons)) throw new Error("Missing Persons Count");
  var medianMap = {
    AK: {
      "1": 76918,
      "2": 99001,
      "3": 110520,
      "4": 127641
    },
    AL: {
      "1": 60786,
      "2": 72639,
      "3": 83278,
      "4": 101771
    },
    AR: {
      "1": 54772,
      "2": 67338,
      "3": 81484,
      "4": 96833
    },
    AZ: {
      "1": 70919,
      "2": 85476,
      "3": 102909,
      "4": 113286
    },
    CA: {
      "1": 76190,
      "2": 99936,
      "3": 112536,
      "4": 130845
    },
    CO: {
      "1": 82716,
      "2": 105627,
      "3": 121560,
      "4": 146972
    },
    CT: {
      "1": 82341,
      "2": 102414,
      "3": 126343,
      "4": 159767
    },
    DC: {
      "1": 88190,
      "2": 145335,
      "3": 182671,
      "4": 219512
    },
    DE: {
      "1": 72804,
      "2": 92178,
      "3": 104376,
      "4": 125676
    },
    FL: {
      "1": 65801,
      "2": 81109,
      "3": 93983,
      "4": 107712
    },
    GA: {
      "1": 62401,
      "2": 81309,
      "3": 98564,
      "4": 114618
    },
    GU: {
      "1": 52478,
      "2": 62748,
      "3": 71504,
      "4": 86528
    },
    HI: {
      "1": 82196,
      "2": 96845,
      "3": 117068,
      "4": 137454
    },
    IA: {
      "1": 63225,
      "2": 84634,
      "3": 100735,
      "4": 115354
    },
    ID: {
      "1": 67671,
      "2": 81103,
      "3": 96652,
      "4": 112868
    },
    IL: {
      "1": 69611,
      "2": 88824,
      "3": 108492,
      "4": 132536
    },
    IN: {
      "1": 63531,
      "2": 78886,
      "3": 96030,
      "4": 112796
    },
    KS: {
      "1": 63366,
      "2": 82770,
      "3": 93960,
      "4": 115176
    },
    KY: {
      "1": 57764,
      "2": 69371,
      "3": 84183,
      "4": 105955
    },
    LA: {
      "1": 53677,
      "2": 69288,
      "3": 78616,
      "4": 98041
    },
    MA: {
      "1": 83430,
      "2": 108534,
      "3": 137635,
      "4": 172104
    },
    MD: {
      "1": 82646,
      "2": 109054,
      "3": 128624,
      "4": 154176
    },
    ME: {
      "1": 68951,
      "2": 83727,
      "3": 101357,
      "4": 117121
    },
    MI: {
      "1": 63994,
      "2": 78404,
      "3": 98800,
      "4": 121273
    },
    MN: {
      "1": 74083,
      "2": 94966,
      "3": 123343,
      "4": 144953
    },
    MO: {
      "1": 63185,
      "2": 79586,
      "3": 98582,
      "4": 108983
    },
    MP: {
      "1": 35241,
      "2": 35241,
      "3": 41001,
      "4": 60304
    },
    MS: {
      "1": 52797,
      "2": 64928,
      "3": 78140,
      "4": 89229
    },
    MT: {
      "1": 67097,
      "2": 81065,
      "3": 97741,
      "4": 115913
    },
    NC: {
      "1": 63611,
      "2": 80315,
      "3": 94750,
      "4": 113793
    },
    ND: {
      "1": 73179,
      "2": 92605,
      "3": 114145,
      "4": 137294
    },
    NE: {
      "1": 65292,
      "2": 89130,
      "3": 103358,
      "4": 120323
    },
    NH: {
      "1": 87356,
      "2": 101521,
      "3": 138320,
      "4": 150913
    },
    NJ: {
      "1": 84257,
      "2": 102903,
      "3": 131173,
      "4": 163110
    },
    NM: {
      "1": 54219,
      "2": 71105,
      "3": 76968,
      "4": 93628
    },
    NV: {
      "1": 67756,
      "2": 83923,
      "3": 96120,
      "4": 107013
    },
    NY: {
      "1": 68795,
      "2": 89052,
      "3": 108589,
      "4": 134443
    },
    OH: {
      "1": 62952,
      "2": 79491,
      "3": 96951,
      "4": 119897
    },
    OK: {
      "1": 58729,
      "2": 73910,
      "3": 84901,
      "4": 97330
    },
    OR: {
      "1": 73344,
      "2": 88926,
      "3": 106818,
      "4": 123799
    },
    PA: {
      "1": 67676,
      "2": 83249,
      "3": 103856,
      "4": 125754
    },
    PR: {
      "1": 30013,
      "2": 30013,
      "3": 35444,
      "4": 49622
    },
    RI: {
      "1": 76377,
      "2": 96200,
      "3": 116185,
      "4": 140947
    },
    SC: {
      "1": 61635,
      "2": 77674,
      "3": 89568,
      "4": 103821
    },
    SD: {
      "1": 61022,
      "2": 92469,
      "3": 96008,
      "4": 116374
    },
    TN: {
      "1": 61951,
      "2": 78250,
      "3": 92789,
      "4": 109852
    },
    TX: {
      "1": 63448,
      "2": 83037,
      "3": 95391,
      "4": 110719
    },
    UT: {
      "1": 82581,
      "2": 92694,
      "3": 109600,
      "4": 124188
    },
    VA: {
      "1": 77420,
      "2": 97833,
      "3": 117300,
      "4": 145585
    },
    VI: {
      "1": 41638,
      "2": 50043,
      "3": 53356,
      "4": 58457
    },
    VT: {
      "1": 76949,
      "2": 94524,
      "3": 118960,
      "4": 142492
    },
    WA: {
      "1": 85482,
      "2": 102797,
      "3": 124869,
      "4": 145341
    },
    WI: {
      "1": 67469,
      "2": 85900,
      "3": 108986,
      "4": 126708
    },
    WV: {
      "1": 57197,
      "2": 65816,
      "3": 78785,
      "4": 96161
    },
    WY: {
      "1": 63413,
      "2": 82927,
      "3": 94681,
      "4": 110604
    }
  };
  return medianMap[state][persons > 4 ? 4 : persons] + (persons > 4 ? (persons - 4) * 11100 : 0);
}

exports.default = getStateMedianFamilyIncome; // Scraping helper script
// const states = {
//   AL: 'Alabama',
//   AK: 'Alaska',
//   AS: 'American Samoa',
//   AZ: 'Arizona',
//   AR: 'Arkansas',
//   CA: 'California',
//   CO: 'Colorado',
//   CT: 'Connecticut',
//   DE: 'Delaware',
//   DC: 'District Of Columbia',
//   FM: 'Federated States Of Micronesia',
//   FL: 'Florida',
//   GA: 'Georgia',
//   GU: 'Guam',
//   HI: 'Hawaii',
//   ID: 'Idaho',
//   IL: 'Illinois',
//   IN: 'Indiana',
//   IA: 'Iowa',
//   KS: 'Kansas',
//   KY: 'Kentucky',
//   LA: 'Louisiana',
//   ME: 'Maine',
//   MH: 'Marshall Islands',
//   MD: 'Maryland',
//   MA: 'Massachusetts',
//   MI: 'Michigan',
//   MN: 'Minnesota',
//   MS: 'Mississippi',
//   MO: 'Missouri',
//   MT: 'Montana',
//   NE: 'Nebraska',
//   NV: 'Nevada',
//   NH: 'New Hampshire',
//   NJ: 'New Jersey',
//   NM: 'New Mexico',
//   NY: 'New York',
//   NC: 'North Carolina',
//   ND: 'North Dakota',
//   MP: 'Northern Mariana Islands',
//   OH: 'Ohio',
//   OK: 'Oklahoma',
//   OR: 'Oregon',
//   PW: 'Palau',
//   PA: 'Pennsylvania',
//   PR: 'Puerto Rico',
//   RI: 'Rhode Island',
//   SC: 'South Carolina',
//   SD: 'South Dakota',
//   TN: 'Tennessee',
//   TX: 'Texas',
//   UT: 'Utah',
//   VT: 'Vermont',
//   VI: 'Virgin Islands',
//   VA: 'Virginia',
//   WA: 'Washington',
//   WV: 'West Virginia',
//   WI: 'Wisconsin',
//   WY: 'Wyoming',
// };
// function innerTextToNumber(str) {
//   return Number((str || '').replace(/[\D|,]/, '').replace(',', ''));
// }
// const unsorted = Array.from(document.querySelectorAll('table thead tr'))
//     .slice(3)
//     .map(r => ({
//       state: Object.keys(states).find(stKey => states[stKey] === Object.values(states).find(st => st.toUpperCase() === (r.querySelector('td:nth-of-type(1)') || {}).innerText)),
//       1: innerTextToNumber((r.querySelector('td:nth-of-type(2)') || {}).innerText),
//       2: innerTextToNumber((r.querySelector('td:nth-of-type(3)') || {}).innerText),
//       3: innerTextToNumber((r.querySelector('td:nth-of-type(4)') || {}).innerText),
//       4: innerTextToNumber((r.querySelector('td:nth-of-type(5)') || {}).innerText),
//     }))
//     .filter(obj => (obj.state || '').length)
//     .reduce((accum, obj) => ({
//       [obj.state]: {
//         1: obj[1],
//         2: obj[2],
//         3: obj[3],
//         4: obj[4],
//       },
//       ...accum,
//     }), {});
// Object.keys(unsorted)
//   .sort()
//   .reduce((acc, key) => {
//     acc[key] = unsorted[key];
//     return acc;
//   }, {});